// extracted by mini-css-extract-plugin
module.exports = {"textBanner":"textBanner_textBanner__HuMyy","moving":"textBanner_moving__1lNCz"};